import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import Container from '../../../Core/Container';
import RichText, { fragment } from '../../../Core/RichText';
import Link from '../../../Core/Link';
import TextWithIcon from '../../TextWithIcon';

import { Wrapper, Img, Content, Title, ButtonWrapper } from './styles';

const LinkImageBanner = ({ data }) => {
  if (!data) return null;

  const {
    theme,
    heading,
    headingStyle,
    imageDam,
    ctas,
    component,
    sectionLayout,
    backgroundColor,
  } = data;

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => (
        <Title className={`${theme} ${headingStyle}`}>{children}</Title>
      ),
      [BLOCKS.HEADING_2]: (_, children) => (
        <Title className={`${theme} ${headingStyle}`}>{children}</Title>
      ),
    },
  };

  return (
    <Container
      className="overflowX-auto-margin"
      backgroundColor={backgroundColor}
    >
      <Wrapper className={`${component} ${sectionLayout}`}>
        {header && (
          <Content>
            {header && <RichText document={heading} options={header} />}
            {ctas && (
              <ButtonWrapper>
                {ctas.map(cta => {
                  if (cta.hideFrench === true) return null;
                  // destructured the cta to have icon and cta separated
                  // fixes the bug on page reload due to deleting icon
                  const { iconDam, ...iconlessCta } = cta;
                  return (
                    <TextWithIcon
                      key={iconlessCta.id}
                      icon={iconDam.asset.localImage.publicURL}
                      type="link-icon"
                    >
                      <Link data={iconlessCta}>
                        <RichText
                          document={iconlessCta.label}
                          options={fragment}
                        />
                      </Link>
                    </TextWithIcon>
                  );
                })}
              </ButtonWrapper>
            )}
          </Content>
        )}
        {imageDam && <Img src={imageDam} alt="" />}
      </Wrapper>
    </Container>
  );
};

LinkImageBanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default LinkImageBanner;
